export const environment = {
  production: false,
  apiUrl: 'https://api.staging.rekruto.io/api/v1',
  // Deployed development builds and `ng serve` use this file; local full-stack work uses
  // `ng serve --configuration local` (environment.local.ts).
};
